import { OnboardingPriceBookItemSchema } from "./onboarding-price-book-item";
import { OnboardingSmartPOSItemSchema } from "./onboarding-smart-pos-item";
import { OnboardingAccountInfoItemSchema } from "./onboarding-account-info-item";
import { OnboardingDCBoxItemSchema } from "./onboarding-dc-box-item";
import { OnboardingWelcomeItemSchema } from "./onboarding-welcome-item";
import { DateValidation } from "../shared/date-validation";
import { z } from "zod";

export const OnboardingItemSchema = z.object({
  Id: z.string().optional(),
  AccountId: z.string().optional(),
  AccountName: z.string().optional(),
  OverallProgress: z.number().optional(),
  BusinessUnitId: z.string().optional(),
  BusinessUnitName: z.string().optional(),
  Created: DateValidation,
  Modified: DateValidation,
  Pricebook: OnboardingPriceBookItemSchema.optional(),
  SmartPOS: OnboardingSmartPOSItemSchema.optional(),
  AccountInfo: OnboardingAccountInfoItemSchema.optional(),
  DCBox: OnboardingDCBoxItemSchema.optional(),
  Welcome: OnboardingWelcomeItemSchema.optional(),
});

export type OnboardingItemType = z.infer<typeof OnboardingItemSchema>;
